(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[961],{

/***/ "Obhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Youtube", function() { return Youtube; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Youtube = function Youtube(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M26.7562 10.2021C26.7562 10.2021 26.5215 8.54756 25.8 7.82081C24.8857 6.86456 23.8643 6.86006 23.3955 6.80381C20.0392 6.56006 15 6.56006 15 6.56006H14.991C14.991 6.56006 9.95175 6.56006 6.5955 6.80381C6.12675 6.86006 5.10525 6.86456 4.191 7.82081C3.46875 8.54756 3.23925 10.2021 3.23925 10.2021C3.23925 10.2021 3 12.1431 3 14.0878V15.9066C3 17.8468 3.23925 19.7923 3.23925 19.7923C3.23925 19.7923 3.474 21.4468 4.191 22.1736C5.10525 23.1298 6.30525 23.0968 6.83925 23.2003C8.7615 23.3833 15 23.4396 15 23.4396C15 23.4396 20.0437 23.4306 23.4 23.1913C23.8687 23.1351 24.891 23.1306 25.8045 22.1743C26.526 21.4476 26.7607 19.7931 26.7607 19.7931C26.7607 19.7931 27 17.8528 27 15.9073V14.0886C26.9955 12.1476 26.7562 10.2028 26.7562 10.2028V10.2021ZM12.516 18.1146V11.3691L18.999 14.7538L12.516 18.1146Z"
  }));
};

/***/ })

}]);